import React from 'react';
import classes from './InfoRow.module.css';

const InfoRow = ({ label, value, isLast = false }) => {
  return (
    <div className={`${classes.infoRow} ${isLast ? classes.last : ''}`}>
      <span className={classes.label}>{label}</span>
      <span className={classes.value}>{value}</span>
    </div>
  );
};

export default InfoRow;
